import { jsx as a } from "react/jsx-runtime";
import { TextLink as t, Theme as n, TextLinkIconPosition as d, TextLinkUnderlineStyle as r, TextLinkStyle as e } from "@nextgen-web-framework/all";
import { DownloadCardIconName as l } from "./types/propsTypes.js";
import '../../../assets/DownloadCard.css';const i = "#ffffff", c = "#396e75", s = "#e5fdff", z = "#546223", V = "#f0fae5", g = "#a65523", C = "#fff1e8", h = "#7f3e3e", k = "#ffe2e2", f = "#62625a", _ = "#f8f8e7", u = "#38539a", m = "#707070", w = "#c8f8d1", B = "#87c9c8", b = "#5291b1", O = "rgba(82, 145, 177, 0.1019607843)", x = "#445685", G = "#181d61", y = "rgba(24, 29, 97, 0.1019607843)", L = "#5969d6", R = "#ea999d", q = "#b6577e", I = "rgba(182, 87, 126, 0.1019607843)", W = "#7e3e80", P = "#1e247f", T = "rgba(30, 36, 127, 0.1019607843)", D = "#da7600", N = "#107f47", S = "#d91734", Y = "_html_opqh4_38", v = "_icon_opqh4_93", A = {
  amwayWhite: i,
  darkBlue: c,
  lightBlue: s,
  darkGreen: z,
  lightGreen: V,
  darkOrange: g,
  lightOrange: C,
  darkRed: h,
  lightRed: k,
  darkYellow: f,
  lightYellow: _,
  darkPurple: u,
  darkGrayOnWhite: m,
  dataVizColor1: w,
  dataVizColor2: B,
  dataVizColor3: b,
  dataVizColor3Background: O,
  dataVizColor4: x,
  dataVizColor5: G,
  dataVizColor5Background: y,
  dataVizColor6: L,
  dataVizColor7: R,
  dataVizColor8: q,
  dataVizColor8Background: I,
  dataVizColor9: W,
  dataVizColor10: P,
  dataVizColor10Background: T,
  dataVizAlertOrange: D,
  dataVizSuccessGreen: N,
  dataVizWarningRed: S,
  "no-visible": "_no-visible_opqh4_34",
  html: Y,
  "downloadcard-container": "_downloadcard-container_opqh4_72",
  "text-link": "_text-link_opqh4_86",
  icon: v,
  "downloadcard-label": "_downloadcard-label_opqh4_100",
  "downloadcard-icon": "_downloadcard-icon_opqh4_108"
}, j = (o) => /* @__PURE__ */ a("div", { className: A["downloadcard-container"], children: /* @__PURE__ */ a(
  t,
  {
    text: o == null ? void 0 : o.label,
    theme: n.PURPLE,
    iconPosition: d.RIGHT,
    underline: r.FIXED,
    rightIcon: { iconName: l.FILE_DOWNLOAD },
    textLinkStyle: e.ICON,
    href: o.url,
    target: o.target
  }
) });
export {
  j as default
};
//# sourceMappingURL=DownloadCard.js.map
